import z from "zod";

export const amendmentListDataSchema = z.object({
  /** ISO year the list opens on. */
  year: z.coerce.number().int().default(new Date().getFullYear()),
});

export type AmendmentListDataProps = z.infer<typeof amendmentListDataSchema>;
